import api from './api';

export type Region = 'EU' | 'US' | 'MX' | 'BR' | 'APAC';

export interface PlatformRegionResponse {
  region: Region;
  default_region: Region;
  supported: Region[];
}

export interface TenantRegionUpdateResponse {
  id: string;
  slug: string;
  region: Region;
}

export const regionSettingsService = {
  async getPlatformRegion(): Promise<PlatformRegionResponse> {
    const { data } = await api.get<PlatformRegionResponse>('/admin/platform/region');
    return data;
  },
  async setPlatformRegion(region: Region): Promise<{ region: Region }> {
    const { data } = await api.patch<{ region: Region }>('/admin/platform/region', { region });
    return data;
  },
  async setTenantRegion(tenantId: string, region: Region): Promise<TenantRegionUpdateResponse> {
    const { data } = await api.patch<TenantRegionUpdateResponse>(
      `/admin/tenants/${tenantId}/region`,
      { region },
    );
    return data;
  },
};

// Region -> Framework mapping kept client-side so the dropdown can show a
// helpful preview without a round-trip to /admin/privacy/framework.
export const REGION_TO_FRAMEWORK: Record<Region, { short: string; full: string }> = {
  EU: { short: 'GDPR', full: 'General Data Protection Regulation' },
  US: { short: 'CCPA', full: 'California Consumer Privacy Act' },
  MX: { short: 'LFPDPPP', full: 'Ley Federal de Proteccion de Datos Personales' },
  BR: { short: 'LGPD', full: 'Lei Geral de Protecao de Dados' },
  APAC: { short: 'PDPA', full: 'Personal Data Protection Act (Singapore)' },
};
